import moment from 'moment';
import i18n from '@/i18n';
import { updateAllObjectifDispoAsync } from '@/api/dispo';
import messageErreur from '@/services/general/messageErreur';
import readFileXlsx from '@/services/general/readFileXlsx';
import validation, { validationLine } from '@/services/planningReseauTempo/validationObjectifDispo';

function fromLignesXlsxToTab(lignesXlsx) {
  const lignes = lignesXlsx.filter(ligne => !!(ligne.ProduitId));
  if (lignes.length === 0) return lignes;
  /**
   * cas où la colonne de semaine n'a pas de valeur dans le fichier
   * cette correction n'est valide que pour les semaines commençant par 01 et finissant à
   * la semaine correspondant à la date de fin
   */
  lignes.forEach(ligne => {
    const lastWeekOnLine = moment(ligne.DateFin).isoWeek();
    [...Array(lastWeekOnLine)]
      .map((_, n) => `S${String(n + 1).padStart(2, '0')}`)
      .forEach(week => {
        ligne[week] = ligne[week] || null;
      });
  });
  return lignes;
}

export default async function readAndCreateLignes(file, msgErrors) {
  try {
    const lignesXlsx = await readFileXlsx(file);
    const tabDonnees = fromLignesXlsxToTab(lignesXlsx);
    if (!tabDonnees.length) {
      msgErrors.push(i18n.t('catalogue.popUpImportExcel.errorNoLineData'));
      throw new Error();
    }
    const { produits, errors } = validationLine(tabDonnees);
    if (errors.length) {
      msgErrors.push(...errors);
      throw new Error();
    }
    await updateAllObjectifDispoAsync({ items: produits });
  } catch (e) {
    if (e && e.response) {
      validation(e.response, msgErrors);
    }
    if (!msgErrors.length) messageErreur(i18n);
    throw (e);
  }
}
